//model for new API
export class Contracts {
  id: number;
  rental: boolean;
  siteEnabled?: boolean;
  siteLicences?: number;
  product: string;
  startDate: any;
  endDate: any;
  comment?: any;
  uuid: string;
  active: boolean;
  activations: Activations;
  vmActivations: VmActivations;
  desktopActivations: DesktopActivations;
  serverLics: number;
  desktopLics: number;
  virtualPacks: number;
  hostTokens?: hostTokens;
  cloneTokens?: cloneTokens;
  syncTokens?: syncTokens;
  upgradeTokens?: usage;
  stagingTokens?: usage;
  raTokens?: usage;
  raBulkTokens?: usage;
  returnsRemaining?: number;
  displayName?: string; // CLONEMANAGER -> CloneManager / PROTECT_FOR_VMS -> Protect for VMs
  capacity?: capacity;
  totalCapacityTB?: number;
}

export class Activations {
  total: number;
  available: number;
}

export class VmActivations {
  total: number;
  available: number;
}

export class DesktopActivations {
  total: number;
  available: number;
}

export class hostTokens {
  total: number;
  available: number;
}

export interface cloneTokens {
  total: number;
  available: number;
}

export interface syncTokens {
  total: number;
  available: number;
}

export interface usage {
  total: number;
  available: number;
}

export interface capacity extends usage {}
